import React from 'react';
import classes from './GrayCardBlueIcon.module.scss'

interface Props {
    iconName: string;
    title: string;
    text: string;
}

const GrayCardBlueIcon = ({iconName, title, text}:Props) => {
    return (
        <div className={classes.block}>
            <img alt='icon' src={require(`../../media/icons/${iconName}.svg`)}/>
            <div className={classes['text-container']}>
                <h5>{title}</h5>
                <span>{text}</span>
            </div>
        </div>
    );
};

export default GrayCardBlueIcon;